import React from 'react'
import {Grid, Card, CardActions, CardContent, CardMedia, Typography} from '@material-ui/core';
import Timeline from '@material-ui/lab/Timeline';
import CustomTimlineItem from '../Timeline/CustomTimelineItem'
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import Enddot from '../Timeline/Enddot'
import HeaderTimeline from '../Timeline/HeaderTimeline';
import Developer from '../../assets/images/mednaj.JPG'
import Btn from '../Button/LayoutBtn'
import {useStyles} from './styles'


const Profile = () => {
    const classes = useStyles();
    return (
        <Card className={classes.parent} elevation={3}>
            <Card elevation={0}>
                <Typography gutterBottom variant="h5" component="h2" className={classes.space}>
                    Mohammed Najjar
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p" style={{paddingLeft: '4%'}}>
                    Full stack developer
                </Typography>
                <CardMedia 
                    className={classes.media}
                    image={Developer}
                    title="developer"
                />
                <CardContent>
                    <Grid item variant="body2" style={{height: 300}}>
                       <Timeline className={classes.timeline}>
                       <HeaderTimeline icon={<CardMembershipIcon />} />
                       <CustomTimlineItem title={'Name'} description={'Mohammed Najjar'} />
                       <CustomTimlineItem title={'Job'} description={'Freelancer'} />
                       <CustomTimlineItem title={'Email'} description={'najjarmedd@gmail.com'} />
                       <CustomTimlineItem title={'Github'} description={'/mednajjar'} />
                        <Enddot />
                       </Timeline>
                    </Grid>
                </CardContent>
            </Card>
            <CardActions>
                <Btn style={classes.btn} />
            </CardActions>
        </Card>
    )
}

export default Profile
